/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicBackupConfiguration extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicBackupConfiguration");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicBackupConfiguration.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicBackupConfiguration>): BackgroundJobPayloadForPeriodicBackupConfiguration {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicBackupConfiguration(), model);
        BackgroundJobPayloadForPeriodicBackupConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicBackupConfiguration>): BackgroundJobPayloadForPeriodicBackupConfiguration {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicBackupConfiguration.newInstance(<BackgroundJobPayloadForPeriodicBackupConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicBackupConfiguration) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicBackupConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicBackupConfiguration): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicBackupConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
